module.exports = __webpack_public_path__ + "static/img/e1.20c7726.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/hot/e1.png
// module id = Vrhd
// module chunks = 0